import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';
import {Suppliers} from './suppliers';

@Injectable()
export class SuppliersService {
    private headers = new Headers({'Content-Type': 'application/json'});

    private api_url_insert_supplier = './api/server.php?cmd=INSERT_SUPPLIER';
    private api_url_search_supplier = './api/server.php?cmd=SEARCH_SUPPLIERS';
    private api_url_modify_supplier = './api/server.php?cmd=MODIFY_SUPPLIER';
    private api_url_delete_supplier = './api/server.php?cmd=DELETE_SUPPLIER';
    private api_url_get_supplier_code = './api/server.php?cmd=GET_SUPPLIER_CODE_LIST';
    private api_url_get_supplier_list = './api/server.php?cmd=GET_SUPPLIER_LIST';
    private api_url_get_supplier_list_by_article = './api/server.php?cmd=GET_SUPPLIER_LIST_BY_ARTICLE';
    
 
    private id_supplier: number;
    private supplier_name: string;
    private supplier_code: string;
    private supplier_address: string;
    private supplier_phone_number: string;
    private supplier_mail: string = '';

    constructor(private http: Http) {}



    InsertSupplier(supplier: Suppliers): Promise<Suppliers[]> {
        this.supplier_name = supplier.supplier_name;
        this.supplier_code = supplier.supplier_code;
        this.supplier_address = supplier.supplier_address;
        this.supplier_phone_number = supplier.supplier_phone_number;
        this.supplier_mail = supplier.supplier_mail;

        return this.http.get(this.api_url_insert_supplier + '&supplier_name=' + this.supplier_name + '&supplier_code=' + this.supplier_code
            + '&supplier_address=' + this.supplier_address + '&supplier_phone_number=' + this.supplier_phone_number
            + '&supplier_mail=' + this.supplier_mail)
            .toPromise()
            .then(response => response.json() as Suppliers[])
            .catch(this.handleError);

    }

    ConfirmModification(supplier: Suppliers): Promise<Suppliers[]> {
        this.id_supplier = supplier.id_supplier;
        this.supplier_name = supplier.supplier_name;
        this.supplier_code = supplier.supplier_code;
        this.supplier_address = supplier.supplier_address;
        this.supplier_phone_number = supplier.supplier_phone_number;
        this.supplier_mail = supplier.supplier_mail;
        return this.http.get(this.api_url_modify_supplier + '&id_supplier=' + this.id_supplier + '&supplier_name=' + this.supplier_name + '&supplier_code=' + this.supplier_code + '&supplier_address=' + this.supplier_address
            + '&supplier_phone_number=' + this.supplier_phone_number + '&supplier_mail=' + this.supplier_mail)
            .toPromise()
            .then(response => response.json() as Suppliers[])
            .catch(this.handleError);
    }


    EditSupplier(supplier: Suppliers): Promise<Suppliers[]> {
        this.id_supplier = supplier.id_supplier;
        this.supplier_name = supplier.supplier_name;
        this.supplier_code = supplier.supplier_code;
        this.supplier_address = supplier.supplier_address;
        this.supplier_phone_number = supplier.supplier_phone_number;
        this.supplier_mail = supplier.supplier_mail;

        return this.http.get(this.api_url_modify_supplier + '&id_supplier=' + this.id_supplier + + '&name=' + this.supplier_name + '&supplier_code=' + this.supplier_code
            + '&supplier_address=' + this.supplier_address + '&supplier_phone_number=' + this.supplier_phone_number + '&supplier_mail=' + this.supplier_mail)
            .toPromise()
            .then(response => response.json() as Suppliers[])
            .catch(this.handleError);

    }

    DeleteSupplier(supplier: Suppliers): Promise<Suppliers[]> {
        this.id_supplier = supplier.id_supplier;

        return this.http.get(this.api_url_delete_supplier + '&id_supplier=' + this.id_supplier)
            .toPromise()
            .then(response => response.json() as Suppliers[])
            .catch(this.handleError);

    }
    SupplierSearch(supplier_name: string, supplier_code: string): Promise<Suppliers[]> {

        return this.http.get(this.api_url_search_supplier + '&supplier_name=' + supplier_name + '&supplier_code=' + supplier_code)
            .toPromise()
            .then(response => response.json() as Suppliers[])
            .catch(this.handleError);
    }
    
    GetSupplierCodeList(): Promise<Object>{
        return this.http.get(this.api_url_get_supplier_code)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError); 
    }
    
    GetSupplierList(): Promise<Object>{
        return this.http.get(this.api_url_get_supplier_list)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError); 
    }
    
    GetSupplierListByArticle(id_article: number): Promise<Object>{
        return this.http.get(this.api_url_get_supplier_list_by_article+'&id_article='+id_article)
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError); 
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// ./src/app/suppliers.service.ts